import { useState } from "react";
import { useMediaQuery } from "@mui/material";
import { useTranslation } from "react-i18next";
import { CustomTypography } from "../../../components/CustomTypography/CustomTypography";
import { CustomIconButton } from "../../../components/CustomIconButton/CustomIconButton";
import { CustomButton } from "../../../components/CustomButton/CustomButton";
import { CustomTypographyLabelValue } from "../../../components/CustomTypographyLabelValue/CustomTypographyLabelValue";
import { getCurrentUser, isFleetAdmin } from "../../../utils/getCurrentFleet";
import { ModalUpdateProfile, ProfileValues } from "./ModalUpdateProfile/ModalUpdateProfile";
import { ModalChangePassword } from "./ModalChangePassword/ModalChangePassword";
import useStyles from "./styles";

export const InformationGeneral = () => {
  const { t } = useTranslation();
  const classes = useStyles();
  const isMobile = useMediaQuery("(max-width:599.95px)");

  // Seed from the cached session; local state lets edits reflect instantly.
  const [user, setUser] = useState<TUser | null>(() => getCurrentUser());
  const [openEdit, setOpenEdit] = useState(false);
  const [openPassword, setOpenPassword] = useState(false);
  const canEdit = isFleetAdmin();

  const onUpdated = (values: ProfileValues) => {
    setUser((prev) => (prev ? { ...prev, ...values } : prev));
  };

  return (
    <div className={classes.divInformationGeneral}>
      <ModalUpdateProfile
        open={openEdit}
        user={user}
        onClose={() => setOpenEdit(false)}
        onUpdated={onUpdated}
      />
      <ModalChangePassword
        open={openPassword}
        user={user}
        onClose={() => setOpenPassword(false)}
      />

      <div className={classes.textInformationGeneral}>
        <CustomTypography
          text={t("setting.generalInformation", "General information")}
          variant={"h3"}
          isUppercase
        />
        {canEdit && (
          <CustomIconButton
            iconName={"pencil"}
            widthIcon={"30px"}
            heightIcon={"30px"}
            onClick={() => setOpenEdit(true)}
          />
        )}
      </div>

      <div className={classes.divInfos}>
        <div className={classes.divInfos2}>
          <CustomTypographyLabelValue
            label={t("collaborator.name", "Name")}
            value={user?.lastname || "-"}
          />
          <CustomTypographyLabelValue
            label={t("collaborator.firstName", "Firstname")}
            value={user?.firstname || "-"}
          />
        </div>
        <div className={classes.divInfos2}>
          <CustomTypographyLabelValue
            label={"Id"}
            value={user?.id ? String(user.id) : "-"}
          />
          <CustomTypographyLabelValue
            label={t("collaborator.email", "Email")}
            value={user?.email || "-"}
            isUppercaseValue={false}
          />
        </div>
      </div>

      <div className={classes.securityRow}>
        <CustomButton
          label={t("setting.resetPassword", "Reinitialiser le mot de passe")}
          variant={"secondary"}
          height={"40px"}
          width={isMobile ? "100%" : "fit-content"}
          onClick={() => setOpenPassword(true)}
        />
      </div>
    </div>
  );
};